import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=4b4f9b7a&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=js"
export * from "./SelectLanguage.vue?vue&type=script&lang=js"
import style0 from "./SelectLanguage.vue?vue&type=style&index=0&id=4b4f9b7a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b4f9b7a",
  null
  
)

export default component.exports